import script from "./AppLoadMoreButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLoadMoreButton.vue?vue&type=script&setup=true&lang=js"

import "./AppLoadMoreButton.vue?vue&type=style&index=0&id=68594758&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68594758"]])

export default __exports__